const features = [
  {
    icon: "ri-shield-check-fill",
    title: "Security First",
    description:
      "Every app we build undergoes rigorous security audits. From data encryption to secure API communication, your users' information is always protected.",
    color: "text-emerald-500",
    bg: "bg-emerald-50",
  },
  {
    icon: "ri-speed-fill",
    title: "Optimized Performance",
    description:
      "Our apps are fine-tuned for Apple hardware, delivering buttery-smooth animations and rapid response times even on older iPhone models.",
    color: "text-amber-500",
    bg: "bg-amber-50",
  },
  {
    icon: "ri-eye-off-fill",
    title: "User Privacy",
    description:
      "We follow a strict zero-data-collection philosophy. No tracking, no selling data — complete user privacy is non-negotiable in everything we build.",
    color: "text-rose-500",
    bg: "bg-rose-50",
  },
  {
    icon: "ri-refresh-fill",
    title: "Continuous Updates",
    description:
      "Our engineering team delivers regular updates aligned with each new iOS release, keeping your app compatible, secure, and feature-rich.",
    color: "text-teal-500",
    bg: "bg-teal-50",
  },
  {
    icon: "ri-apple-fill",
    title: "Native iOS Development",
    description:
      "We code exclusively in Swift and SwiftUI, leveraging the full depth of the Apple platform to create truly native, integrated experiences.",
    color: "text-gray-700",
    bg: "bg-gray-100",
  },
  {
    icon: "ri-customer-service-2-fill",
    title: "Dedicated Support",
    description:
      "Our support team is always available to resolve issues quickly. From bug reports to feature requests — we listen and we act.",
    color: "text-indigo-500",
    bg: "bg-indigo-50",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 bg-white w-full">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-500 text-sm font-semibold uppercase tracking-widest mb-3 block">
            Why Choose Us
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            What Sets Us Apart
          </h2>
          <p className="mt-4 text-gray-500 text-lg max-w-xl mx-auto">
            We combine deep iOS expertise with an unwavering focus on quality, security, and user satisfaction.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-gray-50 rounded-2xl p-8 hover:bg-gray-900 transition-colors duration-300 cursor-default"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${feat.bg} group-hover:bg-white/10 mb-5 transition-colors duration-300`}>
                <i className={`${feat.icon} text-2xl ${feat.color} group-hover:text-white transition-colors duration-300`} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-white mb-3 transition-colors duration-300">
                {feat.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-400 transition-colors duration-300">
                {feat.description}
              </p>
            </div>
          ))}
        </div>

        {/* Tech Stack Ribbon */}
        <div className="mt-20 pt-12 border-t border-gray-100">
          <p className="text-center text-gray-400 text-sm uppercase tracking-widest mb-8">
            Built with Apple&apos;s modern frameworks
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {["Swift", "SwiftUI", "Combine", "Core Data", "CloudKit", "WidgetKit", "StoreKit", "App Clips"].map(
              (tech) => (
                <span
                  key={tech}
                  className="px-5 py-2 rounded-full bg-gray-50 text-gray-600 text-sm font-medium border border-gray-200"
                >
                  {tech}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
